// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1M-WB","column":"style_column__jHSkW","row":"style_row__Mau0N"};